import { render, staticRenderFns } from "./TutorialNoteForm.vue?vue&type=template&id=00bb35c3&"
import script from "./TutorialNoteForm.vue?vue&type=script&lang=js&"
export * from "./TutorialNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports